export default {
  'dashboard-monitor.monitor.trading-activity': 'Real-Time Trading Activity',
  'dashboard-monitor.monitor.total-transactions': 'Total transactions today',
  'dashboard-monitor.monitor.sales-target': 'Sales target completion rate',
  'dashboard-monitor.monitor.remaining-time': 'Remaining time of activity',
  'dashboard-monitor.monitor.total-transactions-per-second': 'Total transactions per second',
  'dashboard-monitor.monitor.activity-forecast': 'Activity forecast',
  'dashboard-monitor.monitor.efficiency': 'Efficiency',
  'dashboard-monitor.monitor.ratio': 'Ratio',
  'dashboard-monitor.monitor.proportion-per-category': 'Proportion Per Category',
  'dashboard-monitor.monitor.fast-food': 'Fast food',
  'dashboard-monitor.monitor.western-food': 'Western food',
  'dashboard-monitor.monitor.hot-pot': 'Hot pot',
  'dashboard-monitor.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboard-monitor.monitor.popular-searches': 'Popular Searches',
  'dashboard-monitor.monitor.resource-surplus': 'Resource Surplus',
  'dashboard-monitor.monitor.fund-surplus': 'Fund Surplus',
};
